import {mergeArray} from "../../../utils/Helpers";

export const handleSubmitParlayPending = (state, action) => {
    state.placingParlayState.status = 'placing';
    state.placingParlayState.error = null;
}

export const handleGetContestsLobbyDataFulfilled = (state, action) => {
    mergeArray(state.contests, action.payload.Contests);
    state.lobbyData = action.payload;
}

export const handleGetContestsByIdsFulfilled = (state, action) => {
    mergeArray(state.contests, action.payload.Contests);
}

export const handleGetActiveUserParlaysFulfilled = (state, action) => {
    const fetchedParlays = action.payload?.Parlays ?? [];
    if (fetchedParlays.length === 0)
        return;

    const existingParlayIds = state.userParlays.map(parlay => parlay.Id);
    fetchedParlays?.forEach(parlay => {
        const index = existingParlayIds.indexOf(parlay.Id);
        if (index !== -1)
            state.userParlays[index] = parlay;
        else
            state.userParlays.push(parlay);
    });
}
export const handleGetUserParlaysHistoryFulfilled = handleGetActiveUserParlaysFulfilled;

export const handleGetPreSelectedParlaysLobbyDataFulfilled = (state, action)=>{
    mergeArray(state.preSelectedParlays, action.payload.PreSelectedParlays);
    if (action.payload.PrizeAssets)
        mergeArray(state.prizeAssets, action.payload.PrizeAssets);
    if (action.payload.Partners)
        mergeArray(state.partners, action.payload.Partners);
}

export const handleGetPreSelectedParlayByIdFulfilled = (state, action) => {
    mergeArray(state.preSelectedParlays, [action.payload.PreSelectedParlay]);
    mergeArray(state.contests, action.payload.Contests.Results );
    if (action.payload.PrizeAsset)
        mergeArray(state.prizeAssets, [action.payload.PrizeAsset]);
    if (action.payload.Partner)
        mergeArray(state.partners, [action.payload.Partner]);
}

export const handleGetPrizeAssetByIdFulfilled = (state, action) => {
    if (action.payload.PrizeAsset)
        mergeArray(state.prizeAssets, [action.payload.PrizeAsset]);
    if(action.payload.Partner)
        mergeArray(state.partners, [action.payload.Partner]);
}

